import { render } from "./Orders.vue?vue&type=template&id=50d3e717"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=50d3e717&lang=scss"
script.render = render

export default script